import React, { useMemo, useState } from 'react';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';
import { DefaultModal } from '../../designComponents/modals/ModalComponent';
import { InputLine } from '../../designComponents/inputs/InputLine';
import { MainButton } from '../../designComponents/buttons/Buttons';

const DatingChattingCreateModal = ({ visible, onClose = () => {}, onCreate }) => {
    const [searchText, setSearchText] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);

    const selectedUserIdMap = useMemo(() => {
        const map = {};
        selectedUsers.forEach((item) => {
            map[item.id] = true;
        });
        return map;
    }, [selectedUsers]);

    const onSubmitSearch = async (e) => {
        e.preventDefault();
        try {
            setSearchLoading(true);
            const response = await RefreshCheckApi.get('/adminUser', {
                params: {
                    size: 10,
                    page: 1,
                    searchType: 1,
                    searchWord: searchText.replaceAll('-', ''),
                },
            });
            setUsers(response?.data?.data || []);
        } catch (error) {
            console.error('error: ', error);
            alert('회원 검색 중 오류가 발생했습니다.');
        } finally {
            setSearchLoading(false);
        }
    };

    const onClickUser = (user) => () => {
        const exists = selectedUsers.find((item) => item.id === user.id);
        if (exists) {
            setSelectedUsers((prev) => prev.filter((item) => item.id !== user.id));
            return;
        }
        if (selectedUsers.length >= 2) {
            alert('유저는 2명까지 선택할 수 있습니다.');
            return;
        }
        setSelectedUsers((prev) => [...prev, user]);
    };
    const createDefaultChatting = async () => {
        await RefreshCheckApi.post('/v2/chatting', {
            send_user_id: selectedUsers[0].id,
            receive_user_id: selectedUsers[1].id,
        });
    };

    const onClickCreate = async () => {
        if (selectedUsers.length !== 2) {
            alert('채팅 유저 2명을 선택해 주세요.');
            return;
        }
        try {
            setCreateLoading(true);
            if (onCreate) await onCreate(selectedUsers);
            else await createDefaultChatting();
            alert('채팅이 생성되었습니다.');
            setSelectedUsers([]);
            setUsers([]);
            setSearchText('');
            onClose();
        } catch (error) {
            console.error('error: ', error);
            alert('채팅 생성에 실패했습니다.');
        } finally {
            setCreateLoading(false);
        }
    };

    return (
        <DefaultModal
            title="채팅 생성"
            visible={visible}
            onClickClose={onClose}
            onClickBottomClose={onClose}
            closeOn={true}
            saveOn={true}
            saveText={createLoading ? '생성 중...' : '생성하기'}
            onClickSave={onClickCreate}
            boxStyle={{ width: '700px', maxWidth: '95%' }}
            bodyWidth={50}
        >
            <form onSubmit={onSubmitSearch} style={{ padding: '16px 20px', borderBottom: '1px solid #eeeeee' }}>
                <InputLine
                    title="전화번호"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.replaceAll('-', ''))}
                    placeholder="숫자만 입력 후 검색하세요."
                    wrapperStyle={{ margin: 0, display: 'flex' }}
                    inputStyle={{ flex: 1, height: '32px' }}
                    buttonOn={true}
                    btnText={searchLoading ? '검색중' : '검색'}
                    onClick={onSubmitSearch}
                />
            </form>

            <div style={{ padding: '12px 20px' }}>
                <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
                    <div style={{ color: 'red' }}>* 편지 데이터를 강제로 생성후 수락처리합니다. 기존 채팅 데이터는 삭제됩니다</div>
                    <div>편지 보낸 유저: {selectedUsers[0] ? `${selectedUsers[0].name}(${selectedUsers[0].id})` : ''}</div>
                    <div>편지 받은 유저: {selectedUsers[1] ? `${selectedUsers[1].name}(${selectedUsers[1].id})` : ''}</div>
                </div>

                <div style={{ maxHeight: '260px', overflow: 'auto', border: '1px solid #f0f0f0', borderRadius: 6 }}>
                    {users.length === 0 ? (
                        <div style={{ padding: '28px 12px', color: '#999', textAlign: 'center' }}>검색 결과가 없습니다.</div>
                    ) : (
                        users.map((item) => {
                            const selected = !!selectedUserIdMap[item.id];
                            return (
                                <button
                                    key={item.id}
                                    type="button"
                                    onClick={onClickUser(item)}
                                    style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        border: 0,
                                        borderBottom: '1px solid #f3f3f3',
                                        backgroundColor: selected ? '#eaf3ff' : '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <div style={{ textAlign: 'left' }}>
                                        <div style={{ fontSize: 13, color: '#333' }}>
                                            {item.name || '-'} / {item.nickname || '-'}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#999' }}>
                                            ID: {item.id} | 전화번호: {item.phone_no || '-'}
                                        </div>
                                    </div>
                                    {selected && <MainButton text="선택됨" style={{ cursor: 'default' }} />}
                                </button>
                            );
                        })
                    )}
                </div>
            </div>
        </DefaultModal>
    );
};

export default DatingChattingCreateModal;
